import {applyLang} from '../i18n';

export function annualEventConfirmation(form, context) {
    const translated = applyLang(form, context.lang);
    return translated?.annualEventProjectId ? translated.annualEventConfig?.confirmationText || '' : '';
}
